/**
 * @generated SignedSource<<753635ab5d0c816924703be3fb3ff1ec>>
 * @relayHash a15cbfaed4f2ffc7c60eb9a43c5f94a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a558d89fa2e157c98f3569b3aef28351cf89f401a7a8afe01ab65155930f61d6

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type hubHomeContentWrapperQuery$variables = {
  cloudId: string;
  hubAri: string;
  hubEditMode: boolean;
  operationType?: HelpCenterMediaConfigOperationType | null;
  pageAri: string;
  sendDraftPages?: boolean | null;
};
export type hubHomeContentWrapperQuery$data = {
  readonly helpCenter: {
    readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference" | "hubHomeContent_AtlassianHubHome_HubInfo">;
  } | null;
  readonly me: {
    readonly user: {
      readonly accountId: string;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};
export type hubHomeContentWrapperQuery = {
  response: hubHomeContentWrapperQuery$data;
  variables: hubHomeContentWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubEditMode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "sendDraftPages"
},
v6 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "pageAri",
    "variableName": "pageAri"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v9 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "asapIssuer"
  },
  {
    "kind": "ScalarField",
    "name": "mediaCollectionName"
  },
  {
    "kind": "ScalarField",
    "name": "mediaToken"
  },
  {
    "kind": "ScalarField",
    "name": "mediaUrl"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "type"
},
v13 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "cornerRadius"
},
v15 = {
  "concreteType": "HelpCenterNavigationBar",
  "kind": "LinkedField",
  "name": "navigationBar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "backgroundColor"
    },
    {
      "kind": "ScalarField",
      "name": "borderColor"
    },
    {
      "kind": "ScalarField",
      "name": "borderType"
    },
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "padding"
    },
    {
      "kind": "ScalarField",
      "name": "positionType"
    },
    {
      "kind": "ScalarField",
      "name": "textColor"
    }
  ]
},
v16 = {
  "kind": "Literal",
  "name": "ids",
  "value": ([]/*: any*/)
},
v17 = {
  "kind": "Variable",
  "name": "sendDraftPages",
  "variableName": "sendDraftPages"
},
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = {
  "concreteType": "HelpCenterPageName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": (v13/*: any*/)
},
v20 = [
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "concreteType": "HelpCenterPageDescription",
    "kind": "LinkedField",
    "name": "description",
    "plural": false,
    "selections": (v13/*: any*/)
  },
  {
    "condition": "sendDraftPages",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isPublished"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
          },
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": "pageMediaConfig",
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "pageAri"
              },
              (v9/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "helpCenterAri",
                "variableName": "hubAri"
              }
            ],
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasUnpublishedChanges"
                  },
                  (v12/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hoistedProjectKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slug"
                  },
                  {
                    "concreteType": "HelpCenterName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": (v13/*: any*/)
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/)
                    ]
                  },
                  {
                    "alias": "allPages",
                    "args": [
                      {
                        "fields": [
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v20/*: any*/)
                  },
                  {
                    "alias": "customPages",
                    "args": [
                      {
                        "fields": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CUSTOM"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v20/*: any*/)
                  },
                  (v12/*: any*/),
                  {
                    "alias": "currentPage",
                    "args": [
                      {
                        "fields": [
                          {
                            "items": [
                              {
                                "kind": "Variable",
                                "name": "ids.0",
                                "variableName": "pageAri"
                              }
                            ],
                            "kind": "ListValue",
                            "name": "ids"
                          },
                          (v17/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "concreteType": "HelpCenterPageLayout",
                        "kind": "LinkedField",
                        "name": "pageLayout",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterLayoutAdf",
                            "kind": "LinkedField",
                            "name": "layoutAdf",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterLayoutAdfContentConnection",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "HelpCenterLayoutAdfContentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "HelpCenterLayoutAdfContent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "content"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "secondaryColor"
                          }
                        ]
                      },
                      (v15/*: any*/),
                      {
                        "concreteType": "HelpCenterBrandingTypography",
                        "kind": "LinkedField",
                        "name": "typography",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "headingFont"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "bodyFont"
                          }
                        ]
                      },
                      (v14/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "spaceDensity"
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "hubAri"
              },
              (v9/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cloudUrl"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v8/*: any*/),
              (v18/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a558d89fa2e157c98f3569b3aef28351cf89f401a7a8afe01ab65155930f61d6",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dc7675289e2113a38d1545105fface86";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
